<template>
    <div class="main">
        <h1>Conditions générales</h1>
        <p>INFORMATIONS DU CLIENT ET CONDITIONS GÉNÉRALES DE VENTE POUR FRANCE</p>
        <h2>1. GÉNÉRALITÉS</h2>
        <h3>1.1. Applicabilité</h3>
        <p>Les présentes conditions générales de vente et tout contrat ou document dont le lien est indiqué ici
            (ci-après nommé « CGV ») s’appliquent à toutes les commandes passées sur https://www.swarovski.com/fr-FR/#/,
            les sites internet et les applications mobiles (ci-après nommés les « Sites internet »). Swarovski France
            S.A.S. est le vendeur des Produits figurant sur les sites Web. Ces sites sont gérés par Swarovski Crystal
            Online AG. Swarovski France S.A.S. sera nommé ci-après « Swarovski » / « Nous » / « à Nous » / « Notre ».
            <br>
            <br>
            Veuillez lire attentivement les CGV avant de commander un(des) Produit(s) (tel qu’il est défini ci-dessous)
            sur les Sites internet. En commandant Nos Produits, vous indiquez que vous êtes d’accord et que vous
            respectez :
            <br><br></p>
        <ul>
            <li>les présentes CGV</li>
            <li>les Conditions d’utilisation de Nos Sites internet et</li>
            <li>Notre Politique de confidentialité</li>
        </ul>
        <p>
            et vous confirmez que vous êtes habilité(e) à conclure un contrat juridiquement contraignant et que vous
            avez
            l’âge requis dans votre pays pour conclure un contrat juridiquement contraignant. Si Nous avons des raisons
            de
            croire que vous ne remplissez pas toutes les conditions mentionnées dans le présent contrat, Nous nous
            réservons
            le droit d’annuler votre commande.
        </p>
        <h3>1.2. Partie contractante</h3>
        <p>Les Sites internet permettant de vendre les biens via Internet sont exploités par : <br>
            <br>
            Swarovski Crystal Online AG <br>
            <br>
            Alte Landstrasse 411 <br>
            <br>
            8708 Männedorf <br>
            <br>
            Suisse <br>
            <br>
            Numéro d’enregistrement de la société : <br>
            <br>
            Registre du commerce de Zurich, HRB CH-020.3.023.942-2 <br>
            <br>
            Numéro de TVA en Suisse : <br>
            <br>
            231’288 <br>
            <br>
            Représenté légalement par son directeur général : <br>
            <br>
            Michele Molon <br>
            <br>
            Dans le cas improbable où vous auriez des réclamations sur tout Produit acheté sur les Sites internet ou si
            vous
            souhaitez faire valoir un recours en garantie légale, vous pouvez Nous contacter à l’adresse ci-dessus ou
            contacter
            Notre Service client par e-mail à l’adresse suivante : customer_relations.fr@swarovski.com.
            <br> <br>
            Si vous sélectionnez une destination de livraison au Royaume-Uni ou en dehors de l’Union européenne,
            veuillez noter
            que les Conditions générales du pays respectif s’appliquent à votre achat et à votre utilisation des Sites
            internet.
            Un lien vers les Conditions générales applicables s’affichera sur les Sites internet du pays respectif et
            sur la
            page de règlement final. Par ailleurs, veuillez noter que l’adresse de facturation doit être dans le pays du
            lieu de
            livraison.</p>
        <h3>1.3. Amendement aux CGV</h3>
        <p>Nous nous réservons le droit de changer ces CGV à tout moment et tout changement sera effectif à partir de la
            publication des nouvelles CGV sur les Sites internet. Vous et tout contrat de ventre entre vous et Nous se
            fera
            conformément à la version de CGV en vigueur au moment de votre commande de Produits sur les Sites
            internet.</p>
        <h2>2. ACCEPTATION DES BONS DE COMMANDES</h2>
        <h3>2.1. Invitation</h3>
        <p>
            Veuillez noter que tous les Produits proposés sur les Sites internet ne sont qu’une invitation à acheter et
            ne
            constituent ni une offre ni une promesse unilatérale de vente de notre part. <br> <br>

            En complétant le processus de Règlement final et en cliquant sur le bouton « ACHETER MAINTENANT », vous
            soumettez
            une offre contraignante de conclusion de contrat d’achat, mais toutes les commandes que vous nous soumettez
            sont
            soumises à Notre acceptation à Notre discrétion. <br> <br>

            Nous sommes libres de ne pas accepter votre commande dans les cas suivants :</p>
        <ul>
            <li>a) non disponibilité des Produits présentés sur les Sites internet ;</li>
            <li>b) Produits dont le prix n’a pas été correctement fixé sur les Sites internet ;</li>
            <li>c) Produits qui n’ont pas été correctement décrits sur les Sites internet ;</li>
            <li>d) si Nous sommes dans l’impossibilité d’obtenir une autorisation de votre paiement ;</li>
            <li>e) si vous violez ces CGV ;</li>
            <li>f) si vous êtes impliqué dans des activités frauduleuses ou criminelles de toute sorte ;</li>
            <li>g) si vous n’êtes pas un client, mais un acheteur.</li>
        </ul>
        <p>
            Si Nous ne pouvons pas accepter votre commande, Nous vous informerons de cette incapacité en vous en
            indiquant
            la
            raison, et ne vous facturerons pas le Produit.
            <br> <br>
            Malheureusement, nous ne livrons pas aux adresses situées hors de France (pays principal).
        </p>
        <h3>2.2. Processus d’enregistrement</h3>
        <p>a) Lorsque vous passez une commande, vous pouvez utiliser la fonction « Commander sans s’identifier» ou vous
            pouvez
            vous enregistrer chez Nous. La différence entre les deux options tient au fait qu’en sélectionnant l’option
            «
            S’enregistrer », vos données seront sur notre fichier pour votre commande de Produits suivante et vous
            n’aurez pas
            besoin d’entrer à nouveau ces informations. Les deux options exigent un formulaire de commande comportant
            des champs
            obligatoires (nom, prénom, adresse, adresse e-mail, numéro de téléphone). Si vous choisissez l’option «
            S’enregistrer », Nous pouvons vous demander de créer et d’utiliser un mot de passe pour avoir accès à vos
            données
            pour la commande de Produits suivante. <br> <br>
            Si Nous vous le demandons, c’est à la stricte condition que vous soyez responsable de la sécurisation et de
            la
            confidentialité de votre mot de passe à tout moment. Vous vous engagez à respecter toutes les consignes
            et/ou
            recommandations de sécurité que Nous vous donnons et à Nous informer immédiatement si vous vous apercevez ou
            si vous
            suspectez toute autorisation non autorisée de votre mot de passe ou si votre mot de passe vient à la
            connaissance
            d’une partie non autorisée. <br><br>
            Sans préjudice de Nos autres droits et recours, Nous pouvons suspendre tout accès aux Sites internet, sans
            engager
            notre responsabilité envers vous, si cette action est nécessaire pour sauvegarder les Sites internet.
            <br><br>
            Vous êtes d’accord avec le fait que le contenu que vous fournissez lorsque vous vous enregistrez sur les
            Sites
            internet n’est pas trompeur et est vrai, précis et complet à tous égards et que vous signalerez Notre
            Service client
            par e-mail à l’adresse customer_relations.fr@swarovski.com de tout changement intervenu dans ces
            informations.
            <br><br>
            b) Au cas où une inactivité prolongée fait échouer votre connexion aux Sites internet, votre sélection de
            Produits
            peut être perdue. Si tel est le cas, vous devrez saisir à nouveau votre sélection. Veuillez noter que les
            Produits
            que se trouvent dans votre panier et sur votre liste de souhait ne sont pas réservés et peuvent être achetés
            par
            d’autres clients et/ou retirés de votre panier. <br>
        </p>
        <h3>2.3. Étapes de la commande</h3>
        <p>
            Aucun contrat d’achat contraignant n’est constitué avant que nous n’acceptions votre commande, tel que
            l’indique la
            section 2.3 (g) ci-dessous. <br><br>

            Vous acceptez qu’une fois que vous avez cliqué sur le bouton « ACHETER MAINTENANT », vos commandes sur les
            Sites
            internet sont des offres contraignantes qui vous obligent à Nous acheter les Produits listés dans votre
            panier sur
            la base des CGV présentes (ci-dessous « Produit » ou « Produits »). <br><br>

            Étapes jusqu’à l’acceptation de votre commande <br><br>

            a) Après avoir choisi et placé un Produit dans votre panier, vous êtes dirigé vers la page de paiement et de
            règlement final (ci-après nommé « Règlement final»). Après avoir sélectionné un mode de paiement et de
            livraison,
            vous pourrez activer le bouton « ACHETER MAINTENANT» à la fin du processus de Règlement final. En cliquant
            sur le
            bouton « ACHETER MAINTENANT », vous soumettez une offre contraignante de conclusion de contrat d’achat.
            <br><br>
            b) Avant de soumettre votre offre, vous aurez l’opportunité de revoir votre sélection, de vérifier le prix
            total de
            votre commande, de corriger tout erreur de saisie et de choisir des modes de paiement et de livraison.
            <br><br>
            c) La disponibilité des articles, les prix et les options de livraison peuvent varier selon la destination
            de
            livraison.
            <br><br>
            d) Les variations dans les processus de fabrication que Nous utilisons ainsi que les propriétés d’affichage
            des
            matériels informatiques que vous utilisez pour voir les Sites internet peuvent influencer la couleur des
            Produits
            affichés sur les Sites internet et les Produits qui vous sont livrés peuvent présenter des différences
            mineurs par
            rapport à ceux affichés à l’écran. Nous pouvons aussi procéder à des changements mineurs sur les Produits
            afin de
            refléter les modifications apportées aux lois et prescriptions réglementaires applicables.
            <br><br>
            e) Nous n’acceptons pas les commandes dont l’adresse de livraison que vous nous indiquez est celle d’une
            entité ou
            d’une personne fournissant des services de transitaire. Au cas où Nous acceptons une commande, quelle
            qu’elle soit,
            et que Nous nous apercevons ultérieurement que l’adresse de livraison de cette commande est celle d’une
            entité ou
            d’une personne fournissant des services de transitaire, Nous sommes en droit d’annuler cette commande après
            vous en
            avoir informé par e-mail ou par téléphone.
            <br><br>
            f) Une fois que vous Nous avez soumis une offre contraignante, vous recevrez un e-mail de confirmation de
            commande
            avec vos adresses de facturation et de livraison, le numéro de commande, les détails des Produits choisis
            par vous,
            le prix final et le mode d’expédition. Cet e-mail n’est pas une acceptation de votre offre/commande, mais
            seulement
            une confirmation que Nous avons reçu votre commande.
            <br><br>
            g) L’acceptation de votre offre/commande et la conclusion d’un contrat d’achat est indiqué par ce qui suit :
            <br><br>
            (a) un e-mail confirmant que les Produits commandés ont été envoyés ; ou
            <br><br>
            (b) si vous avez sélectionné l’option « Click & Collect » – si ce service est disponible – (tel que le
            décrit la
            section 3.3.), Nous vous envoyons un e-mail confirmant que les Produits ont été envoyés au magasin Swarovski
            concerné et peuvent être retirés dans un délai de sept (7) jours ouvrables à partir de et en incluant la
            date de
            l’e-mail de confirmation ; ou
            <br><br>
            (c) si vous avez sélectionné l’option « Click & Reserve » – si ce service est disponible – (tel que le
            décrit la
            section 3.2.), Nous vous envoyons un e-mail confirmant que les Produits ont été réservés au Magasin
            Swarovski
            concerné – et vous vous rendez à Notre magasin dans les deux (2) jours ouvrables suivants pour acheter le
            Produit
            dans le Magasin Swarovski ; ou
            <br><br>
            Lorsque vous venez retirer les Produits que vous avez achetés via « Click & Collect » , nous pouvons vous
            demander
            d’apporter au Magasin Swarovski la preuve de votre identité avec une photo originale (telle qu’un passeport
            ou une
            carte d’identité) ainsi que la carte de paiement utilisée pour passer la commande (le cas échéant).
            <br><br>
            Si vous avez changé d’avis une fois le(s) Produit(s) acheté(s), veuillez-vous reporter à la section 7 pour
            connaître
            vos droits à retourner le Produit et recevoir un remboursement.
            <br><br>
            Veuillez noter s’il vous plaît que l’option consistant à venir retirer les Produits dans un Magasin
            Swarovski n’est
            possible que dans certains pays dans des Magasins Swarovski sélectionnés. La liste des Magasins de la
            société
            Swarovski fournissant ce service vous sera communiquée au cours de la procédure de commande.
            <br><br>
            Veuillez noter qu’une fois votre commande soumise, Nous ne pouvons ni modifier ni annuler votre commande. Si
            vous
            souhaitez annuler votre commande, veuillez contacter Notre Service client via e-mail.
            customer_relations.fr@swarovski.com.
        </p>
        <h2>3. DISPONIBILITÉ</h2>
        <h3>3.1. Disponibilité générale</h3>
        <p>
            Les Produits ne sont disponibles que tant qu’ils sont en stock. Le niveau de stock disponible indiqué est
            mis à jour
            régulièrement, mais il ne garantit pas que le Produit commandé sera disponible lorsque vous vous rendrez au
            Magasin
            Swarovski concerné (si l’option que vous avez choisi le permet). Nous nous réservons le droit de modifier
            sans
            préavis et à tout moment les Produits offerts à la vente sur les Sites internet (mais ces changements ne
            s’appliquent pas aux Produits pour lesquels vous avez passé commande). Nous nous réservons aussi le droit de
            limiter, si raison légitime il y a, le nombre de Produits qui peuvent vous être vendus.
            <br><br>
            Dans le cas improbable où les Produits que vous avez commandés ne sont pas disponibles, Nous vous en
            informerons
            durant le processus de commande et vous serez remboursé via le mode de paiement utilisé pour acheter le(s)
            Produit(s).
            <br><br>
            Nous ne sommes pas responsables si certains Produits ne sont pas en stock ou sont indisponibles.
        </p>
        <h3>3.2. Click & Reserve</h3>
        <p>
            Nous pouvons vous donner l’option de vérifier la disponibilité de certains Produits et de réserver sur les
            Sites
            internet les Produits dans des Magasins Swarovski spécifiés (« Click & Reserve »). Si le Produit est
            disponible, le
            magasin le réserve pour vous durant deux (2) jours ouvrables à partir de notre notification, en conformité
            avec la
            section n 2.3., point g) (c). Vous pouvez acheter le Produit dans le Magasin Swarovski concerné. Les prix
            dans les
            Magasins Swarovski peuvent être différents des Prix affichés sur les Sites internet.
        </p>
        <h3>3.3. Click & Collect</h3>
        <p>
            Nous pouvons vous proposer l’option (si elle est applicable dans votre pays) d’acheter un Produit en ligne
            et de le
            retirer dans le Magasin Swarovski désigné (Click & Collect). Si la commande n’a pas été retirée dans les
            sept (7)
            jours ouvrables suivant l’envoi de Notre e-mail de confirmation, conformément à la section 2.3, point
            g),(d), Nous
            supposerons que vous ne voulez pas y donner suite, nous annulerons la commande et la section 7.2
            s’appliquera.
        </p>
        <h2>4. PRIX ET COÛTS SUPPLÉMENTAIRES</h2>
        <h3>4.1. Prix des Produits</h3>
        <p>
            Tous les prix des Produits sur les Sites internet sont uniquement les prix des Produits. Ils incluent la TVA
            (et
            autres taxes de vente), mais ils ne comprennent pas le coût de livraison (le cas échéant). Veuillez
            consulter Nos
            informations sur
            <br><br>
            Le prix total de votre commande, y compris tous les frais accessoires et de livraison, sera indiqué à la fin
            du
            processus de règlement final. En confirmant la commande, vous affirmez que vous êtes d’accord sur le prix de
            celle-ci et tout particulièrement sur celu des Produits. Le prix ne peut pas être ajusté après la fin du
            processus
            de règlement final.
            <br><br>
            Veuillez noter les points suivants : Toutes les commandes sont passées auprès de France S.A.S., qui est une
            entité
            française. Si les opérations de votre carte de crédit / de débit ou autre mode de paiement ne sont pas
            libellées
            dans la devise de l’achat, le prix final sera facturé dans la devise de votre carte. C’est votre émetteur de
            carte
            qui calcule et facture ces frais. Swarovski n’a pas de contrôle sur ces frais et ne peut pas en prédire le
            montant.
            Veuillez contacter votre banque émettrice pour plus d’informations avant de passer votre commande.
        </p>
        <h3>4.2. Erreur d’évaluation des prix</h3>
        <p>
            Veuillez noter que si le prix correct d’un Produit est inférieur au prix fixé sur les Sites internet, sous
            réserve
            de Notre droit de refuser une commande selon les présentes CGV, Nous facturerons le montant le moins élevé
            et vous
            enverrons le Produit.
            <br><br>
            Si le prix correct d’un Produit est supérieur au prix fixé sur les Sites internet, Nous vous contacterons, à
            notre
            discrétion, pour vous demander vos instructions avant d’accepter votre commande. Si Nous acceptons et
            traitons votre
            commande alors que l’erreur de prix est flagrante et sans équivoque et peut être raisonnablement reconnu par
            vous
            comme une erreur d’évaluation de prix, Nous pouvons mettre un terme au contrat, vous rembourser la somme que
            vous
            avez payée et exiger le retour des Produits, quels qu’ils soient, qui vous ont été livrés.
        </p>
        <h3>4.3. Changements de prix</h3>
        <p>Nous pouvons modifier les prix des produits listés sur les Sites internet sans préavis et à tout moment, mais
            ces
            changements ne s’appliquent pas aux Produits pour lesquels vous avez passé commande.
        </p>
        <h2>5. CONDITIONS DE PAIEMENT</h2>
        <h3> 5.1. Prix total</h3>
        <p>
            Le prix total de votre commande sera le prix d’achat du(des) Produit(s) que vous avez choisi(s) y compris la
            TVA et
            tout frais supplémentaire (p. ex. frais de livraison, etc.). Pour en savoir plus, consulter les Options et
            délais
            d’expédition, dates de livraison prévue et régions sans livraison.
            <br><br>
            Le prix total des Produits commandés est dû lorsque vous avez passé votre commande via les Sites internet.
        </p>
        <h3>5.2. Modes de paiement</h3>
        <p>
            Le paiement peut être effectué par les moyens suivants:
            <br><br>
            a) Carte de crédit / de débit
            <br><br>
            Si vous payez par carte de crédit / de débit (en entrant vos données de paiement sur les Sites internet du
            fournisseur de paiement respectif), Nous nous réservons le droit de valider le nom, l’adresse et d’autres
            informations personnelles que vous avez fournis durant le processus de commande et de les comparer aux bases
            de
            données de tiers adéquates. En fournissant vos données de paiement, vous consentez à ce que ces contrôles
            soient
            effectués. Veuillez noter que nous faisons cela uniquement pour confirmer votre identité, et non pour
            effectuer un
            contrôle de crédit et votre notation de crédit n’en sera pas affectée. Toutes les informations fournies par
            vous
            seront traitées de manière sécurisée et strictement en conformité avec toutes les lois applicables à la
            protection
            des données et à Notre Politique de confidentialité.
            <br><br>
            Vous confirmez que la carte de crédit / de débit que vous utilisez est la vôtre et que tous les détails que
            vous
            Nous fournissez sur ce mode de paiement, y compris et sans limitation, les indications de vos nom et adresse
            sont
            complets, corrects et précis. Vous confirmez en outre que la carte de crédit / de débit est valable et que
            les
            modalités de paiement saisies sont correctes. Si l’institution qui a émis la carte de crédit Nous refuse
            l’autorisation de paiement, Nous n’accepterons pas la commande et Nous ne serons pas responsables de tout
            retard ou
            de l’échec de la livraison et Nous ne serons pas obligés de vous informer de la raison de ce refus.
            <br><br>
            Nous ne sommes pas responsables de tout frais ou autres montants qui peut être appliqués par votre émetteur
            de carte
            ou votre banque résultant du traitement par Nous de votre paiement par carte de crédit / de débit
            conformément à
            votre commande.
            <br><br>
            Si les opérations de votre carte de crédit / de débit ne sont pas libellées dans la devise de votre achat
            indiquée
            sur les Sites internet, le prix final peut être facturé dans la devise de votre carte ou de votre compte. Ce
            prix
            final est calculé et facturé par votre émetteur de carte ou votre banque et Nous ne sommes donc pas
            responsables de
            tout coût, dépense, frais ou autre passif encouru ou supporté par vous, en conséquence du fait que votre
            émetteur de
            carte vous facture une devise différente de celle de votre achat telle qu’elle est affichée sur les Sites
            internet.
            <br><br>
            b) PayPal
            <br><br>
            Si vous payez en utilisant PayPal, la Politique de confidentialité de PayPal disponible sur le site internet
            de
            PayPal s’applique également. Cette politique fixe la manière dont PayPal collecte, conserve, traite, partage
            et
            transfère vos données personnelles lorsque vous utilisez ses services.
            <br><br>
            c) Autres modes de paiements
            <br><br>
            Vous pourrez voir les différents modes de paiement que Nous vous proposons sur la page de Règlement final où
            vous
            pourrez choisir un mode de paiement disponible dans votre pays. Nous nous réservons le droit d’ajouter ou de
            retirer
            des modes de paiement à Notre discrétion. Vous pouvez régler Nos demandes de paiement uniquement en
            utilisant des
            créances incontestés ou définitives et sans appel.
        </p>
        <h3>5.3. Débit</h3>
        <p>
            Selon le mode de paiement choisi, les solutions suivantes se présentent à vous : –
            <br><br>
            a) Nous pouvons faire une autorisation préalable de fonds (avec les frais de livraison correspondants)
            immédiatement
            lors de la commande sur votre carte de crédit (à moins que vous n’ayez choisi l’option de « Date de
            livraison prévue
            ») après la passation de votre commande et vous facturer les Produits achetés s’ils vous ont été envoyés ;
            <br><br>
            b) Nous pouvons vous facturer immédiatement les Produits (avec les frais de livraison correspondants) ;
            <br><br>
            c) si vous avez choisi l’option « Click & Collect», Nous pouvons vous facturer les Produits (avec les frais
            de
            livraison correspondants) après que ceux-ci ont été envoyés pour livraison au Magasin Swarovski concerné ;
            ou
            <br><br>
            sauf si Nous vous informons que pour certains Produits, le paiement sera fait en avance lors de votre
            passation de
            commande ou peu après votre passation de commande.
        </p>
        <h3>5.4. Conditions de paiement</h3>
        <p>
            Pour votre sécurité, le nom et l’adresse de facturation doivent correspondre à ceux de la carte de crédit ou
            autre
            méthode utilisée pour le paiement. Tout compte Alipay, PayPal ou Klarna utilisé doit être libellé au nom
            indiqué sur
            votre pièce d’identité émise par le gouvernement. Nous nous réservons le droit d’annuler toute commande qui
            ne
            respecte pas cette condition ou nos autres critères de sécurité.
        </p>
        <h3>5.5. Devise</h3>
        <p>
            Nous acceptons les paiements dans la devise du pays de la destination de livraison sélectionnée. Pour en
            savoir
            plus, consulter les Options et délais d’expédition, dates de livraison et régions sans livraison.
            <br><br>
            Si les opérations de votre carte de crédit / de débit ou les modes de paiement ne sont pas libellées dans la
            devise
            de votre achat indiquée sur les Sites internet, le prix final peut être facturé dans la devise de votre
            carte ou de
            votre compte. Ce prix final est calculé et facturé par votre émetteur de carte ou votre banque ou par le
            fournisseur
            du mode de paiement de sorte que Nous ne sommes pas responsables de tout coût, dépense, frais ou autre dette
            encouru
            ou supporté par vous, résultant du fait que votre émetteur de carte ou votre fournisseur de mode de paiement
            vous
            facture dans une devise différente de celle de votre achat tel qu’elle apparait sur les Sites internet.
        </p>
        <h2>6. LIVRAISON ET RÉSERVE DE PROPRIÉTÉ</h2>
        <h3>6.1. Livraison</h3>
        <p>
            Dans le processus de règlement final, vous pouvez sélectionner votre mode de paiement préféré même s’il
            diffère de
            ceux proposés avec l’adresse de livraison choisie. Nous nous efforcerons d’envoyer votre commande en
            conformité avec
            le délai de livraison estimé tel qu’il est précisé dans les Options et délais d’expédition, dates de
            livraison
            prévue et régions sans livraison ou défini autrement dans le processus de Règlement final au moment de votre
            passation de commande.
            <br><br>
            Les Produits commandés seront livrés à l’adresse de livraison que vous avez indiquée dans Notre contrat de
            prestations de services de livraison. Veuillez vous assurer que vous indiquez une adresse de livraison
            correcte et
            valable. Nous ne pouvons pas être tenus responsables d’une adresse de livraison incorrecte ou incomplète.
            <br><br>
            Veuillez noter que les changements d’adresses de livraison ne sont pas autorisés une fois la commande
            passée.
            <br><br>
            Si Notre fourniture de Produits est retardée par un événement en dehors de Notre contrôle, Nous vous
            contacterons
            dès qu’il est raisonnablement possible de le faire et Nous prendrons les mesures nécessaires pour minimiser
            les
            effets de ce retard. Si nous sommes amenés à prendre ces mesures, Nous ne serons pas responsables des
            retards causés
            par l’événement, mais s’il y a un risque de retard important, vous pouvez Nous contacter pour mettre fin au
            contrat
            et recevoir un remboursement de tout Produit quel qu’il soit que vous avez payé et que vous n’avez pas reçu.
            <br><br>
            Si vous avez demandé de retirer les Produits dans l’un de Nos magasins Swarovski, vous pouvez les retirer
            chez Nous
            à tout moment durant les heures d’ouverture des Magasins Swarovski concernés. Veuillez utiliser Notre page
            Finder
            des Magasins Swarovski pour trouver les adresses et les heures d’ouverture de nos magasins.
            <br><br>
            Veuillez noter que Nous ne livrons ni dans les hôtels ni dans les boîtes postales.
            <br><br>
            À réception du colis, il est obligatoire de contrôler si le contenu du colis est complet.
            <br><br>
            Nous nous efforcerons de livrer les Produits à une heure précise si vous l’avez demandé, mais Nous ne
            pouvons pas
            faire de promesse contraignante sur ce point.
        </p>
        <h3>6.2. Réserve de propriété</h3>
        <p>
            Les Produits restent Notre propriété jusqu’au paiement complet du prix d’achat.
            <br><br>
            À réception du Produit, vous êtes responsable de tout risque d’endommagement ou de perte du Produit. Si vous
            choisissez l’option Click & Collect (lorsque cela est possible), vous serez responsable de tout risque
            d’endommagement ou de perte des Produits au moment du retrait des Produits dans le Magasin Swarovski
            désigné.
            <br><br>
            Veuillez noter que, dans la limite de la loi applicable en vigueur, toute revente ou distribution
            commerciale de Nos
            Produits vendus sur les Sites internet est strictement interdite.
        </p>
        <h2>7. DROIT D’ANNULATION</h2>
        <h3>7.1. Processus d’annulation</h3>
        <p>
            En tant que consommateur, vous avez le droit d’annuler le contrat de vente que vous avez conclu avec Nous
            dans les
            quatorze (14) jours ouvrables qui suivent la réception de vos Produits, sans en indiquer la raison.
            <br><br>
            Votre droit d’annulation commence à la date de passation de commande et termine quatorze (14) jours
            ouvrables après
            la date à laquelle vous recevez votre commande (ci-après nommée « Date limite d’annulation »). Vous devez
            obligatoirement renvoyer le(s) Produit(s) dans les quatorze (14) jours après la Date limite d’annulation.
            <br><br>
            Veuillez noter qu’il n’est pas possible de retourner les Produits personnalisés ou les bijoux piercing pour
            des
            raisons d’hygiène et de sécurité. Cette clause n’affecte pas vos droits légaux.
            <br><br>
            Étapes d’annulation :
            <br><br>
            a) Veuillez Nous informer à l’adresse suivante :
            <br><br>
            Swarovski France S.A.S.
            <br><br>
            13 Boulevard Berthier
            <br><br>
            75017 Paris
            <br><br>
            France
            <br><br>
            E-mail: customer_relations.fr@swarovski.com
            <br><br>
            Afin de respecter la Date limite d’annulation, il vous suffit d’envoyer un message annulant une commande
            (par e-mail
            ou par lettre) avant que la Date limite d’annulation n’expire. Vous pouvez utiliser le formulaire
            d’annulation, mais
            ce dernier n’est pas obligatoire.
            <br><br>
            b) Placez l’(les) article(s) dans la boîte d’envoi d’origine. Vous devez faire tout votre possible pour
            renvoyer les
            Produits dans leur état d’origine avec leur emballage d’origine et le bon de retour doit être fixé aux
            Produits.
            <br><br>
            c) Remplissez le bon de retour (inclus dans le colis d’origine) et placez-le dans la boîte.
            <br><br>
            d) Retirez toutes les autres étiquettes à l’extérieur de la boîte.
            <br><br>
            e) Collez l’étiquette de retour et la facture (incluse dans le colis d’origine) à l’extérieur de la boîte et
            fermez
            solidement le colis.
            <br><br>
            f) Apportez le colis au bureau de poste le plus proche et envoyez-le. L’étiquette est pré-payée, le retour
            est donc
            gratuit. Conservez soigneusement une copie du reçu postal en vue d’une utilisation ultérieure.
            <br><br>
            g) Si vous avez perdu l’étiquette de retour, veuillez Nous envoyer un e-mail à l’adresse suivante :
            customer_relations.fr@swarovski.com et Nous vous enverrons une nouvelle étiquette.
            <br><br>
            –
            <br><br>
            FORMULAIRE D’ANNULATION
            <br><br>

            Veuillez copier et coller le formulaire ci-dessous, remplissez les informations demandées et retournez le
            formulaire
            soit par la poste en recommandé à Swarovski France S.A. Ssoit par e-mail à l’adresse suivante :
            customer_relations.fr@swarovski.com.
            <br><br>
            À :
            <br><br>
            Swarovski France S.A.S.
            <br><br>
            13 Boulevard Berthier
            <br><br>
            75017 Paris
            <br><br>
            Je [nom], soussigné, déclare que j’annule mon contrat de vente pour les biens suivants :
            <br><br>
            [PRÉCISEZ LES BIENS] <br>
            Commandés le [DATE] et/ou reçus le [DATE]<br>
            Nom du(des) client(s) :<br>
            Adresse du(des) client(s) :<br>
            Signature du(des) client(s) (uniquement si ce formulaire est envoyé par papier) :<br>
            Date :<br>
        </p>
        <h3>7.2. Effets de l’annulation</h3>
        <p>
            a) Nous vous rembourserons tous les paiements reçus de vous, y compris les coûts de la livraison standard la
            moins
            chère proposée par Nous (p. ex. si vous avez choisi de vous faire livrer le Produit à un coût plus élevé,
            Nous ne
            vous rembourserons que ce que vous auriez payé pour le type de livraison standard la moins chère proposée).
            <br><br>
            b) Nous vous rembourserons avec le même mode de paiement que la transaction initiale ; vous ne supporterez
            de toute
            façon aucun frais résultant de ce remboursement. Veuillez noter que si vous payez complètement par Carte
            cadeau, le
            montant payé ne peut être que remboursé par carte cadeau. Si vous avez payé partiellement par Carte cadeau,
            le
            montant payé par le mode de paiement que vous avez choisi sera remboursé en premier lieu par le même mode de
            paiement. Tout montant restant sera ensuite remboursé sur votre Carte cadeau.
            <br><br>
            c) Nous vous rembourserons dans les quatorze (14) jours à partir de la date à laquelle vous aurez été
            informé(e) de
            votre annulation ou, si plus tôt, le jour où nous aurons reçu de vous le(s) Produit(s) retourné(s) ou que
            vous nous
            aurez fourni la preuve que vous nous avez bien renvoyé ce(s) Produit(s).
            <br><br>
            d) Si vous avez payé des droits ou des taxes directement aux autorités concernés pour l’importation des
            Produits que
            vous souhaitez retourner, Nous déclinons toute responsabilité pour toute demande de remboursement de ces
            droits ou
            taxes.
            <br><br>
            e) Nous pourrons réduire le remboursement (à l’exception des frais de livraison) si le(s) Produit(s) a/ont
            été
            endommagé(s) suite à une mauvaise manipulation de votre part . Si Nous vous remboursons le prix payé avant
            que Nous
            soyons en mesure d’inspecter le(s) Produit(s) et découvrons par la suite que vous l’(les) avez manipulé(s)
            de
            manière inacceptable, vous devez Nous payer un montant approprié.
            <br><br>
            f) Veuillez conserver votre notice de livraison jusqu’à obtention du remboursement.
            <br><br>
            g) Si l’article que vous retournez a été acheté dans une devise autre que la devise locale, tout
            remboursement sera
            effectué dans la devise de l’achat. En raison des fluctuations des taux de change, le montant remboursé peut
            être
            supérieur ou inférieur au prix payé à l’origine.
            <br><br>
            h) Les bons et les Produits personnalisés ne peuvent généralement être ni remplacés ni retournés.
            <br><br>
            i) Il n’est actuellement pas possible de retourner les Produits achetés dans les Magasins Swarovski par
            l’intermédiaire des Sites internet.
            <br><br>
            j) Veuillez noter que si vous décidez de ne retourner qu’une partie d’une commande qui a été réglée avec une
            offre
            de réduction ou une promotion, l’offre de réduction ou la promotion sera recalculée.
            <br><br>
            k) Si vous décidez de ne retourner qu’une partie d’une commande qui a été réglée moyennant l’application
            d’une offre
            de remise ou d’une promotion, le montant d’achat minimal correspondant à l’offre sera appliqué au montant
            remboursé,
            la valeur de la remise sera ajustée en conséquence et seul le montant correspondant à l’article retourné
            sera
            remboursé. Si les articles retournés représentent un total restant inférieur au niveau d’achat minimal de
            l’offre,
            la remise sera déduite du montant remboursé.
            <br><br>
            Par exemple, une remise de 10 % (avec un montant d’achat minimal de 100 Euros) sera déduite si le(s)
            produit(s)
            retourné(s) représentent une valeur totale inférieure à 100 Euros. En cas de promotion avec paiements
            échelonnés, le
            montant le plus bas sera toujours remboursé.
        </p>
        <h2>8. GARANTIE</h2>
        <p>
            Nous garantissons que les Produits sont de qualité marchande et sont exempts de défauts de matériaux ou de
            main
            d’œuvre, à condition qu’ils fassent l’objet d’une utilisation normale. Nous ne fournissons aucune garantie
            supplémentaire.
            <br><br>
            La période de garantie est de deux ans à réception du(des) Produit(s).
            <br><br>
            Cette garantie ne couvre pas les dommages causés aux Produits par accident, mauvaise utilisation ou abus,
            modification, tentative de réparation, négligence après l’achat, usure ordinaire et/ou non-respect des
            consignes de
            soins du Produit.
            <br><br>
            Dans le cas improbable où des défauts ou non-conformités seraient constaté(e)s sur votre(vos) Produit(s)
            avant
            l’échéance de cette garantie, veuillez contacter le service client customer_relations.fr@swarovski.com ou
            vous
            rendre au Magasin Swarovski le plus proche. Nous vous demanderons une preuve d’achat (p. ex. le reçu d’achat
            ou de
            cadeau), assurez-vous que vous conservez celui-ci en lieu sûr. Vous aurez le choix entre recevoir un Produit
            de
            remplacement, s’il existe, ou obtenir un remboursement total.
            <br><br>
            Pour le Service après-vente, veuillez contacter : customer_relations.fr@swarovski.com.
        </p>
        <h2>9. RESPONSABILITÉ</h2>
        <p>
            Swarovski est responsable envers vous uniquement dans le cas de dommages directs causés par nous ou nos
            produits et
            prévisibles au moment de la conclusion du contrat.
            <br><br>
            Nous ne pourrons être tenus responsables des dommages suivants :
            <br><br>
            toute perte économique (y compris et sans limitation, la perte de revenus, de données, de profits actuels ou
            anticipés, de contrats, d’affaires, d’opportunité ou d’économies anticipées) ; ou
            toute atteinte à la clientèle ou à la réputation ; ou
            toute autre perte ou dommage spécial, indirect ou consécutif supporté ou encouru par vous résultant de ou
            étant en
            lien avec les présentes CGV.
        </p>
        <h2>10. PROTECTION DES DONNÉES</h2>
        <p>
            Vos données personnelles seront traitées conformément à notre Politique de confidentialité. Veuillez vous
            reporter à
            Notre Politique de confidentialité si vous souhaitez recevoir plus d’informations sur la manière dont Nous
            utilisons
            les cookies, le type d’informations que nous collectons, comment et à quelles fins Nous utilisons vos
            informations
            et dans quelles circonstances Nous révélons ces informations. Notre Politique de confidentialité (y compris
            des
            informations sur l’utilisation des cookies) est incluse dans les présences CGV et en fait partie.
            <br><br>
            En outre, lorsque vous utilisez PayPal comme mode de paiement, vos données personnelles seront traitées en
            conformité avec la politique de confidentialité de PayPal (veuillez vous reporter à la section 5.2 points
            (b) et
            (c)).
        </p>
        <h2>11. AUTRES MODALITÉS IMPORTANTES</h2>
        <h3>11.1. Nous pouvons transférer ce contrat à une autre personne</h3>
        <p>
            Nous pouvons transférer Nos droits et obligations selon les présentes CGV à une autre entité légale de
            Swarovsky ou
            à un tiers avec lequel Nous avons une relation juridique. Nous nous assurerons toujours que le transfert
            n’affectera
            pas vos droits conformément aux présentes CGV.
        </p>
        <h3>11.2. Vous avez besoin de Notre consentement pour transférer vos droits à une autre personne</h3>
        <p>Vous ne pouvez transférer vos droits ou vos obligations selon les présentes CGV à une autre personne qu’avec
            Notre
            autorisation écrite.
        </p>
        <h3>11.3. Aucune autre personne n’a de droits sur ces CGV.</h3>
        <p>
            Ces CGV sont conclues entre vous et Nous. Aucune autre personne n’aura le droit d’appliquer une quelconque
            de ces
            dispositions.
        </p>
        <h3>11.4. Si un tribunal estime que certaines parties des présentes CGV sont illégales, les autres parties
            resteront en
            vigueur.</h3>
        <p>
            Chaque section des présentes CGV fonctionne séparément. Si tout tribunal ou toute autorité concernée décide
            que
            l’une de ces sections est illégale, les autres sections resteront pleinement applicables.
        </p>
        <h3>11.5. Même si Nous tardons à appliquer ces CGV, Nous pouvons faire valoir nos droits à une date
            ultérieure</h3>
        <p>
            Si Nous n’insistons pas immédiatement sur les obligations et interdictions qui vous sont imposées par les
            présentes
            <br><br>
            CGV, ou Si nous tardons à prendre des mesures contre vous suite à une violation par vous des présentes CGV,
            cela ne
            signifie pas que vous n’avez pas ces obligations ni ces interdictions et cela ne Nous empêchera pas de
            prendre des
            mesures contre vous ultérieurement.
        </p>
        <h3>11.6. Droits de propriété intellectuelle</h3>
        <p>
            Le Groupe Swarovski, ou un tiers propriétaire concerné, conserve tous les droits, titres et intérêts (y
            compris le
            copyright, le design, les marques déposées, les brevets ou autres droits de propriété intellectuelle) sur
            tous
            matériaux utilisés sur les Sites internet, y compris et sans limitation, les textes, noms, designs de
            produits,
            logos, images, graphiques, vidéos et autres œuvres d’art (nommés-ci-après « Contenu »). Aucun contenu des
            Sites
            internet ne doit être interprété comme l’octroi de toute licence ou de tout droit d’utilisation de tout
            Contenu
            affiché sur les Sites internet.
            <br><br>
            Vous pouvez parcourir librement le Contenu des Sites internet, mais vous n’êtes autorisé à télécharger, voir
            ou
            utiliser ce Contenu des Sites internet que pour votre usage personnel, non commerciale, étant donné que le
            Contenu
            et tous les avis de copyright ou autre avis de propriété restent inchangés. En outre, nous vous demandons
            d’ajouter
            la note suivante sur ce type de reproductions : © Swarovski. Tous droits réservés.
            <br><br>
            En plus de la permission ci-dessus, vous ne pouvez pas modifier, adapter, reproduire ni changer les Sites
            internet
            ou leur Contenu ni incorporer les Sites internet ou leur contenu dans aucun autre site internet, en ligne,
            sur une
            plateforme ou outil similaire. Tout usage commercial est interdit sans l’autorisation écrite préalable de
            Swarovski.
            <br><br>
            SWAROVSKI et le logo du CYGNE sont des marques déposées de Swarovski AG Le Groupe Swarovski surveille
            l’utilisation
            de ses marques déposées et prendra des mesures adéquates pour lutter contre toute forme de violation de
            propriété
            intellectuelle.
        </p>
        <h3>11.7. Loi applicable à ces CGV et lieu compétent pour engager des poursuites judiciaires</h3>
        <p>
            Les présentes CGV sont régies par la loi française. La Convention des Nations Unies sur les contrats pour la
            Vente
            internationale de biens ne s’applique pas. Elles n’affectent pas vos droits juridiques en tant que
            consommateur dans
            le pays dans lequel vous êtes situé.
            <br><br>
            Résolution des litiges en ligne pour les clients
            <br><br>
            Le client résidant en Europe doit savoir que la Commission européenne a mis en place une plateforme en ligne
            pour
            les résolutions alternatives de litiges qui fournit une méthode amiable pour résoudre tout litige lié à ou
            issu de
            contrats de vente et de services en ligne. En conséquence, si vous êtes un client européen, vous pouvez
            utiliser
            cette plateforme pour la résolution de tout litige provenant d’un contrat en ligne que vous avez conclu avec
            le
            Propriétaire. La plateforme est disponible sur le lien suivant (http://ec.europa.eu/consumers/odr/).
            Swarovski
            adhère au Service du Médiateur du e-commerce de la FEVAD (Fédération du e-commerce et de la vente à
            distance) dont
            les coordonnées sont les suivantes : 60 rue de la Boétie – 75008 Paris – .
            <br><br>
            Dernière révision le 10 mars 2020.
            <br><br>
            Copyright © 2020 Swarovski. Tous droits réservés.
            <br><br>
            SWAROVSKI et le logo de l’AUTRUCHE sont des marques déposées de Swarovski AG
        </p>
    </div>
</template>

<script>
    export default {
        name: "CondiGeneral"
    }
</script>

<style scoped>

    .main{
        margin: 30px 20%;
        text-align: left;
    }

</style>